import { render, staticRenderFns } from "./my-donation.vue?vue&type=template&id=4f2cf38a&scoped=true&"
import script from "./my-donation.vue?vue&type=script&lang=js&"
export * from "./my-donation.vue?vue&type=script&lang=js&"
import style0 from "./my-donation.vue?vue&type=style&index=0&id=4f2cf38a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2cf38a",
  null
  
)

export default component.exports